import { useState, useEffect } from 'react';
import api from '../api';
import stili from './competenze/stili';
import { validaPassword, REGOLA_PASSWORD_CLIENTE, LUNGHEZZA_MINIMA_PASSWORD_CLIENTE } from '../utils/regolaPassword';

// Creazione di un account cliente sotto il controllo di chi lo crea: l'azienda si sceglie dall'anagrafica (ricerca per nome, CF/P.IVA,
// codice azienda) oppure si crea una nuova anagrafica "da completare" senza uscire dal modulo. Stesso identificativo = si sceglie quella
// esistente; nome simile = "Forse è…", da confermare a mano; il nome non unisce mai nulla in automatico.
export default function NuovoAccountCliente({ onChiudi, onSalvato }) {
  const [cerca, setCerca] = useState('');
  const [risultati, setRisultati] = useState([]);
  const [scelta, setScelta] = useState(null);        // anagrafica scelta
  const [nuova, setNuova] = useState(false);
  const [dati, setDati] = useState({ ragione_sociale: '', codice_fiscale: '', partita_iva: '' });
  const [controllo, setControllo] = useState(null);
  const [confermaNuova, setConfermaNuova] = useState(false);
  const [account, setAccount] = useState({ nome: '', cognome: '', email: '' });
  const [modoPassword, setModoPassword] = useState('genera');
  const [password, setPassword] = useState('');
  const [errore, setErrore] = useState('');
  const [salvataggio, setSalvataggio] = useState(false);

  // ricerca nell'anagrafica
  useEffect(() => {
    if (scelta || nuova || cerca.trim().length < 2) { setRisultati([]); return undefined; }
    const t = setTimeout(async () => {
      try { setRisultati((await api.get('/account-clienti/anagrafiche', { params: { cerca: cerca.trim() } })).data); } catch { setRisultati([]); }
    }, 300);
    return () => clearTimeout(t);
  }, [cerca, scelta, nuova]);

  // controllo della nuova anagrafica: identificativo già presente, Cestino, nomi simili, avvisi formali
  useEffect(() => {
    if (!nuova || !(dati.ragione_sociale.trim() || dati.codice_fiscale.trim() || dati.partita_iva.trim())) { setControllo(null); return undefined; }
    const t = setTimeout(async () => {
      try {
        setControllo((await api.get('/account-clienti/controlla', { params: { nome: dati.ragione_sociale, codice_fiscale: dati.codice_fiscale, partita_iva: dati.partita_iva } })).data);
      } catch { setControllo(null); }
    }, 400);
    return () => clearTimeout(t);
  }, [nuova, dati]);

  const scegli = (a) => { setScelta(a); setNuova(false); setControllo(null); setConfermaNuova(false); setErrore(''); };
  const cambiaDati = (campo, valore) => { setDati(d => ({ ...d, [campo]: valore })); setConfermaNuova(false); };
  const identificativoDato = dati.codice_fiscale.trim() || dati.partita_iva.trim();
  const uguali = controllo?.identificativo_esistente || [];
  const simili = controllo?.simili || [];
  const nelCestino = controllo?.eliminate || [];
  const bloccataDa = scelta && (!scelta.ha_identificativo ? 'L\'anagrafica non ha codice fiscale né partita IVA: completala in Anagrafiche prima di creare l\'account.'
    : scelta.ha_account ? 'Questa azienda ha già un account cliente.'
      : scelta.scheda_intermittenti && !scelta.scheda_intermittenti.attiva ? 'La scheda di Intermittenti di questa azienda è disattivata: riattivala prima.' : '');

  const salva = async (e) => {
    e.preventDefault();
    setErrore('');
    if (!scelta && !nuova) { setErrore('Scegli l\'azienda dall\'anagrafica oppure creane una nuova'); return; }
    if (nuova && !identificativoDato) { setErrore('Per creare un account servono il codice fiscale o la partita IVA dell\'azienda'); return; }
    if (nuova && uguali.length) { setErrore('Esiste già un\'azienda con lo stesso codice fiscale o partita IVA: scegli quella dall\'anagrafica'); return; }
    if (nuova && simili.length && !confermaNuova) { setErrore('Esistono aziende con un nome simile: scegli quella giusta oppure conferma che è una nuova azienda'); return; }
    if (bloccataDa) { setErrore(bloccataDa); return; }
    if (modoPassword === 'scelta') { const e2 = validaPassword(password, account.email, 'cliente'); if (e2) { setErrore(e2); return; } }
    setSalvataggio(true);
    try {
      const corpo = { ...account, ...(modoPassword === 'scelta' ? { password } : {}) };
      if (scelta) corpo.anagrafica_id = scelta.id;
      else { corpo.nuova_anagrafica = { ragione_sociale: dati.ragione_sociale, codice_fiscale: dati.codice_fiscale || undefined, partita_iva: dati.partita_iva || undefined }; if (confermaNuova) corpo.conferma_nuova = true; }
      const res = await api.post('/auth/registra-cliente', corpo);
      onSalvato(res.data);
    } catch (err) {
      const d = err.response?.data || {};
      setErrore(d.errore || 'Errore nel salvataggio');
    } finally {
      setSalvataggio(false);
    }
  };

  return (
    <div style={stili.overlay} role="dialog" aria-label="Nuovo account cliente">
      <div style={{ ...stili.modal, maxWidth: '640px' }}>
        <h3 style={{ marginTop: 0 }}>Nuovo account cliente</h3>
        <form onSubmit={salva}>
          {errore && <div role="alert" style={stili.errore}>{errore}</div>}

          <div style={stili.campo}>
            <label style={stili.label} htmlFor="nac-cerca">Azienda (dall'anagrafica)</label>
            {scelta ? (
              <div style={{ display: 'flex', gap: '0.6rem', alignItems: 'center', flexWrap: 'wrap' }} aria-label="Azienda scelta">
                <strong>{scelta.ragione_sociale}</strong>
                <span style={{ color: '#777', fontSize: '0.85rem' }}>{[scelta.codice_fiscale, scelta.partita_iva, scelta.codice_azienda].filter(Boolean).join(' · ')}</span>
                <button type="button" onClick={() => { setScelta(null); setCerca(''); }} style={stili.btnSmall}>Cambia</button>
              </div>
            ) : (
              <>
                {!nuova && (
                  <input id="nac-cerca" type="text" value={cerca} onChange={e => setCerca(e.target.value)} placeholder="Cerca per nome, codice fiscale / P.IVA o codice azienda…" style={stili.input} autoComplete="off" />
                )}
                {!nuova && risultati.length > 0 && (
                  <ul aria-label="Risultati" style={{ listStyle: 'none', margin: '0.3rem 0 0', padding: 0, border: '1px solid #eee', borderRadius: '6px', maxHeight: '200px', overflow: 'auto' }}>
                    {risultati.map(r => (
                      <li key={r.id} style={{ borderBottom: '1px solid #f3f3f3' }}>
                        <button type="button" onClick={() => scegli(r)} style={{ all: 'unset', cursor: 'pointer', display: 'block', width: '100%', padding: '0.45rem 0.6rem', boxSizing: 'border-box' }}>
                          <strong>{r.ragione_sociale}</strong>{' '}
                          <span style={{ color: '#777', fontSize: '0.82rem' }}>{[r.codice_fiscale, r.partita_iva, r.codice_azienda].filter(Boolean).join(' · ') || 'senza identificativo'}</span>
                          {r.ha_account && <span style={etichetta('#b45309')}>Ha già un account</span>}
                          {!r.ha_account && r.scheda_intermittenti && r.scheda_intermittenti.attiva && <span style={etichetta('#15803d')}>Ha la scheda di Intermittenti</span>}
                          {!r.ha_account && r.scheda_intermittenti && !r.scheda_intermittenti.attiva && <span style={etichetta('#b91c1c')}>Scheda disattivata</span>}
                          {!r.scheda_intermittenti && <span style={etichetta('#555')}>Scheda di Intermittenti da creare</span>}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
                {!nuova && cerca.trim().length >= 2 && risultati.length === 0 && <p style={{ color: '#888', fontSize: '0.84rem', margin: '0.3rem 0 0' }}>Nessuna azienda trovata in anagrafica.</p>}
                {!nuova
                  ? <button type="button" onClick={() => { setNuova(true); setDati(d => ({ ...d, ragione_sociale: cerca.trim() })); }} style={{ ...stili.btnSmall, marginTop: '0.5rem' }}>Non c'è: crea una nuova anagrafica</button>
                  : <button type="button" onClick={() => { setNuova(false); setControllo(null); }} style={stili.btnSmall}>← Torna alla ricerca</button>}
              </>
            )}
            {bloccataDa && <div role="alert" style={{ ...stili.errore, marginTop: '0.5rem' }}>{bloccataDa}</div>}
          </div>

          {nuova && (
            <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '0.7rem', marginBottom: '0.9rem' }} aria-label="Nuova anagrafica">
              <div style={{ fontSize: '0.8rem', color: '#666', marginBottom: '0.5rem' }}>Nasce come anagrafica "da completare" se mancano dati; si completa poi in Anagrafiche.</div>
              <div style={stili.campo}>
                <label style={stili.label} htmlFor="nac-ragione">Ragione sociale</label>
                <input id="nac-ragione" type="text" value={dati.ragione_sociale} onChange={e => cambiaDati('ragione_sociale', e.target.value)} required style={stili.input} />
              </div>
              <div style={stili.row}>
                <div style={stili.campo}>
                  <label style={stili.label} htmlFor="nac-cf">Codice fiscale</label>
                  <input id="nac-cf" type="text" value={dati.codice_fiscale} onChange={e => cambiaDati('codice_fiscale', e.target.value)} maxLength={16} style={stili.input} />
                </div>
                <div style={stili.campo}>
                  <label style={stili.label} htmlFor="nac-piva">Partita IVA</label>
                  <input id="nac-piva" type="text" value={dati.partita_iva} onChange={e => cambiaDati('partita_iva', e.target.value)} maxLength={20} style={stili.input} />
                </div>
              </div>
              {!identificativoDato && <div style={{ color: '#9a3412', fontSize: '0.84rem' }}>Serve almeno il codice fiscale o la partita IVA: senza, l'account non si può creare.</div>}
              {(controllo?.avvisi || []).filter(a => a.codice === 'CF_NON_VALIDO' || a.codice === 'PIVA_NON_VALIDA').map(a => <div key={a.codice} style={{ color: '#9a3412', fontSize: '0.84rem' }}>{a.messaggio}</div>)}
              {uguali.length > 0 && (
                <div role="status" aria-label="Già in anagrafica" style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '6px', padding: '0.5rem 0.7rem', marginTop: '0.5rem', fontSize: '0.86rem' }}>
                  Con questo codice fiscale / partita IVA c'è già: <strong>{uguali[0].ragione_sociale}</strong>.{' '}
                  <button type="button" onClick={() => scegli({ id: uguali[0].id, ragione_sociale: uguali[0].ragione_sociale, codice_fiscale: uguali[0].codice_fiscale, partita_iva: uguali[0].partita_iva, ha_identificativo: true, scheda_intermittenti: null, ha_account: false })} style={stili.btnSmall}>Usa questa</button>
                </div>
              )}
              {nelCestino.length > 0 && <div role="status" style={{ color: '#9a3412', fontSize: '0.84rem', marginTop: '0.5rem' }}>Con questo codice c'è un'azienda nel Cestino delle Anagrafiche: ripristinala da lì.</div>}
              {uguali.length === 0 && simili.length > 0 && (
                <div role="status" aria-label="Forse è" style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '6px', padding: '0.5rem 0.7rem', marginTop: '0.5rem', fontSize: '0.86rem' }}>
                  <strong>Forse è:</strong>
                  <ul style={{ margin: '0.3rem 0', paddingLeft: '1.1rem' }}>
                    {simili.slice(0, 5).map(s => (
                      <li key={s.id}>{s.ragione_sociale}{s.somiglianza === 'uguale' ? ' (stesso nome)' : ''}{' '}
                        <button type="button" onClick={() => scegli({ id: s.id, ragione_sociale: s.ragione_sociale, ha_identificativo: true, scheda_intermittenti: null, ha_account: false, daSimile: true })} style={stili.btnSmall}>È questa</button>
                      </li>
                    ))}
                  </ul>
                  <label style={{ display: 'flex', gap: '0.4rem', alignItems: 'center' }}>
                    <input type="checkbox" checked={confermaNuova} onChange={e => setConfermaNuova(e.target.checked)} />
                    È un'altra azienda: crea una nuova anagrafica
                  </label>
                </div>
              )}
            </div>
          )}

          <hr style={{ border: 'none', borderTop: '1px solid #eee', margin: '1rem 0' }} />
          <p style={{ color: '#666', fontSize: '0.85rem', margin: '0 0 0.8rem' }}>Credenziali di accesso per l'azienda</p>
          <div style={stili.row}>
            <div style={stili.campo}>
              <label style={stili.label} htmlFor="nac-nome">Nome</label>
              <input id="nac-nome" type="text" value={account.nome} onChange={e => setAccount(a => ({ ...a, nome: e.target.value }))} required style={stili.input} />
            </div>
            <div style={stili.campo}>
              <label style={stili.label} htmlFor="nac-cognome">Cognome</label>
              <input id="nac-cognome" type="text" value={account.cognome} onChange={e => setAccount(a => ({ ...a, cognome: e.target.value }))} required style={stili.input} />
            </div>
          </div>
          <div style={stili.campo}>
            <label style={stili.label} htmlFor="nac-email">Email di accesso (login)</label>
            <input id="nac-email" type="email" value={account.email} onChange={e => setAccount(a => ({ ...a, email: e.target.value }))} required style={stili.input} />
          </div>
          <fieldset style={{ border: 'none', padding: 0, margin: '0 0 0.6rem' }}>
            <legend style={stili.label}>Password iniziale</legend>
            <label style={{ display: 'block', fontSize: '0.88rem' }}><input type="radio" name="nac-modo" checked={modoPassword === 'genera'} onChange={() => setModoPassword('genera')} /> Genera automaticamente (mostrata una sola volta)</label>
            <label style={{ display: 'block', fontSize: '0.88rem' }}><input type="radio" name="nac-modo" checked={modoPassword === 'scelta'} onChange={() => setModoPassword('scelta')} /> Scelta manuale dell'operatore</label>
            {modoPassword === 'scelta' && (
              <div style={{ marginTop: '0.4rem' }}>
                <input type="text" aria-label="Password scelta" value={password} onChange={e => setPassword(e.target.value)} autoComplete="off" required minLength={LUNGHEZZA_MINIMA_PASSWORD_CLIENTE} style={stili.input} />
                <div style={{ color: '#888', fontSize: '0.78rem', marginTop: '0.2rem' }}>{REGOLA_PASSWORD_CLIENTE}</div>
              </div>
            )}
          </fieldset>
          <p style={{ color: '#888', fontSize: '0.8rem', margin: 0 }}>Il cliente dovrà cambiarla al primo accesso. Chi gestisce gli account potrà rivederla con "Mostra password".</p>

          <div style={stili.azioni}>
            <button type="button" onClick={onChiudi} style={stili.btnSecondary}>Annulla</button>
            <button type="submit" disabled={salvataggio} style={stili.btn}>{salvataggio ? 'Salvataggio...' : 'Crea account'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

const etichetta = colore => ({ marginLeft: '0.5rem', fontSize: '0.72rem', color: colore, border: `1px solid ${colore}`, borderRadius: '10px', padding: '0 0.4rem', whiteSpace: 'nowrap' });
